import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
import { graphql } from 'gatsby';
import { ComponentHeader } from 'components/thumbprint-components';
export const pageQuery = graphql`
    {
        # Get links to by path to display in the navbar.
        platformNav: allSitePage(filter: { path: { glob: "/components/text-area/*/" } }) {
            edges {
                node {
                    ...PlatformNavFragment
                }
            }
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentHeader data={props.data} mdxType="ComponentHeader" />
    <p><inlineCode parentName="p">{`ThumbprintTextArea`}</inlineCode>{` is a multi-line ThumbprintEditText. For iOS and web parity, this is referred to as a Text Area. Since `}<inlineCode parentName="p">{`ThumbprintTextArea`}</inlineCode>{` inherits from `}<inlineCode parentName="p">{`ThumbprintEditTextBase`}</inlineCode>{`, it shares common properties with `}<inlineCode parentName="p">{`ThumbprintTextInput`}</inlineCode>{`.`}</p>
    <h3>{`States`}</h3>
    <p>{`The following states are available for inputs: Default, selected, filled, disabled, and error.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/native-text-area-states.png",
        "alt": "Text Area states",
        "title": "text-area states"
      }}></img></p>
    <h3>{`Implementation`}</h3>
    <p>{`The following are the new attributes added on top of Andriod’s default EditText:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`hasError`}</inlineCode>{` : Boolean. Indicates whether the Text Area is currently in an error state.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`isDisabled`}</inlineCode>{` : Boolean. Indicates whether the Text Area is currently in a disabled state.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`state`}</inlineCode>{` : Boolean. Returns the current state of the Text Area. Can not be set.`}</li>
    </ul>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      